import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { MenuModel }
from '../../models/configuration/menu.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class GetAllMenuUseCase implements UseCase<void,MenuModel> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute():Observable<MenuModel> {
        return this.repository.getAllMenu();
    }
}